import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Calendar, Users, Activity } from 'lucide-react';
import { StatsCard } from './components/StatsCard';
import { StatusBadge } from './components/StatusBadge';
import { mockKPIs, mockSessions, mockBookings } from './mockData';
export function AdminDashboard() {
  const upcomingSessions = mockSessions.filter(s => s.status === 'active' || s.status === 'full').slice(0, 4);
  const recentBookings = mockBookings.slice(0, 5);
  return <div className="space-y-8" data-id="element-356">
      <div data-id="element-357">
        <h1 className="font-display text-3xl font-bold text-earth mb-2" data-id="element-358">
          Dashboard
        </h1>
        <p className="text-stone" data-id="element-359">Resumen de tu negocio en tiempo real.</p>
      </div>

      {/* KPI Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-360">
        <StatsCard title="Ingresos esta semana" value={`$${mockKPIs.revenueWeek.toLocaleString()}`} subtitle="USD" icon={<DollarSign size={24} data-id="element-362" />} delay={0.1} data-id="element-361" />
        <StatsCard title="Reservas esta semana" value={mockKPIs.bookingsWeek} subtitle="Clases agendadas" icon={<Calendar size={24} data-id="element-364" />} delay={0.2} data-id="element-363" />
        <StatsCard title="Ocupación promedio" value={`${mockKPIs.occupancyRate}%`} subtitle="De capacidad total" icon={<Activity size={24} data-id="element-366" />} delay={0.3} data-id="element-365" />
        <StatsCard title="Total alumnos" value={mockKPIs.totalStudents} subtitle="Registrados" icon={<Users size={24} data-id="element-368" />} delay={0.4} data-id="element-367" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-369">
        {/* Upcoming Sessions */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.4
      }} className="bg-white rounded-2xl border border-mist shadow-sm overflow-hidden" data-id="element-370">
          <div className="p-5 border-b border-mist bg-sand/30 flex justify-between items-center" data-id="element-371">
            <h2 className="font-bold text-earth text-lg" data-id="element-372">Próximas Sesiones</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-373">
            <table className="w-full text-sm text-left" data-id="element-374">
              <thead className="text-xs text-stone uppercase bg-sand/10 border-b border-mist" data-id="element-375">
                <tr data-id="element-376">
                  <th className="px-5 py-3 font-semibold" data-id="element-377">Fecha / Hora</th>
                  <th className="px-5 py-3 font-semibold" data-id="element-378">Clase</th>
                  <th className="px-5 py-3 font-semibold" data-id="element-379">Lugares</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-mist" data-id="element-380">
                {upcomingSessions.map(session => <tr key={session.id} className="hover:bg-sand/10 transition-colors" data-id="element-381">
                    <td className="px-5 py-4" data-id="element-382">
                      <div className="font-medium text-earth" data-id="element-383">
                        {session.session_date}
                      </div>
                      <div className="text-stone text-xs" data-id="element-384">
                        {session.start_time}
                      </div>
                    </td>
                    <td className="px-5 py-4" data-id="element-385">
                      <div className="font-medium text-earth" data-id="element-386">
                        {session.class_name}
                      </div>
                      <div className="text-stone text-xs" data-id="element-387">
                        {session.location_name}
                      </div>
                    </td>
                    <td className="px-5 py-4" data-id="element-388">
                      <div className="flex items-center gap-2" data-id="element-389">
                        <span className="font-medium text-earth" data-id="element-390">
                          {session.capacity - session.spots_available}/
                          {session.capacity}
                        </span>
                        <StatusBadge status={session.status} data-id="element-391" />
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* Recent Bookings */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.4
      }} className="bg-white rounded-2xl border border-mist shadow-sm overflow-hidden" data-id="element-392">
          <div className="p-5 border-b border-mist bg-sand/30 flex justify-between items-center" data-id="element-393">
            <h2 className="font-bold text-earth text-lg" data-id="element-394">Reservas Recientes</h2>
          </div>
          <div className="divide-y divide-mist" data-id="element-395">
            {recentBookings.map(booking => <div key={booking.id} className="p-5 hover:bg-sand/10 transition-colors flex items-center justify-between" data-id="element-396">
                <div data-id="element-397">
                  <p className="font-medium text-earth" data-id="element-398">
                    {booking.student_name}
                  </p>
                  <p className="text-xs text-stone" data-id="element-399">
                    {booking.class_name} • {booking.session_date}
                  </p>
                </div>
                <div className="flex flex-col items-end gap-2" data-id="element-400">
                  <span className="font-bold text-earth" data-id="element-401">
                    ${booking.amount_paid}
                  </span>
                  <StatusBadge status={booking.payment_status} data-id="element-402" />
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </div>;
}